<div class="content-with-filled-button success-pco-screen">
  <div class="main row">
    <div class="col-4 col-pr-12 col-sm-8 col-md-12 col-lg-12 col-xl-12">
      <div [ngStyle]="{'padding': isGrayZone ? '0' : ''}" class="head-description">
        <div *ngIf="!isGrayZone">
          <p class="descriptions">
            {{ copyService.copies[copyProperty].head_description_test }}
          </p>
        </div>
        <ng-container *ngIf="isGrayZone">
          <h1 class="head-title">{{ copyService.getParametrizedCopy('head_title', [userId.firstname], copyProperty) }}
          </h1>
          <p class="description">{{ copyService.copies[copyProperty].head_description }}</p>
          <p id="documents-container" [innerHTML]="copyService.copies[copyProperty].document_description"></p>
          <h2> {{ copyService.copies[copyProperty].solicitation_label }} </h2>
          <div id="solicitation-info">
            <h2> {{copyService.copies[copyProperty].solicitation_number}} </h2>
            <p> {{codBizagi}} </p>
          </div>
        </ng-container>
        <!-- <ng-container *ngIf="!isGrayZone && productSelected.product_type == 'creditCard'">
          <p id="documents-container" [innerHTML]="copyService.copies[copyProperty].document_description"></p>
          <h2> {{ copyService.copies[copyProperty].solicitation_label }} </h2>
          <div id="solicitation-info">
            <h2> {{copyService.copies[copyProperty].solicitation_number}} </h2>
            <p> {{codBizagi}} </p>
          </div>
        </ng-container> -->
        <div *ngIf="!isGrayZone">
          <div class="voxel-mb-m">
            <voxel-card class="card">
              <div VoxelCardTitle>
                <voxel-form-selection>
                  <div class="head-description1">
                    {{ copyService.copies[copyProperty].head_description1 }}
                  </div>
                  <div class="head-description2">
                    {{ copyService.copies[copyProperty].head_description2 }}
                    <p class="amount">
                      {{
                      copyService.getParametrizedCopy(
                      'amount_pco',
                      [amountAproved],
                      copyProperty
                      )
                      }}
                    </p>
                  </div>
                </voxel-form-selection>
              </div>
              <div class="description_card" VoxelCardDescription>
                <voxel-form-selection>
                  <div class="switch-button">
                    <input type="checkbox" name="switch-button" id="switch-label" class="switch-button_checkbox" />
                    <label for="switch-label" (click)="selectActiveBtns()" class="switch-button_label"></label>
                    <p class="description">
                      {{ copyService.copies[copyProperty].body_description2 }}
                    </p>
                  </div>
                  <div [hidden]="!show" class="line"></div>
                  <div [hidden]="!show" class="content_form">
                    <form [formGroup]="formGroup">
                      <span class="reduce_quota">{{
                        copyService.copies.success_pco.reduce_quota
                        }}</span>
                      <vcl-form-field class="how_need" [ngClass]="{ color_error: !aproved }"
                        [label]="copyService.copies.success_pco.how_need"
                        [msgError]="copyService.copies.success_pco.error_amount">
                        <input vclInput id="amountAprovedValueInput" appMoney placeholder="{{
                        copyService.copies.success_pco.amount_placeholder
                      }}" max="999999999999" (input)="validate()"  formControlName="quotaValueInput"/>
      
      
                        <div *ngIf="aproved">
                          {{ copyService.copies.success_pco.amount
                          }}{{ amountAproved }}
                        </div>
                        <div class="error_span" *ngIf="!aproved">
                          {{ copyService.copies.success_pco.error_amount
                          }}{{ amountAproved }}
                        </div>
                        <br />
                        <span class="note">{{
                          copyService.copies.success_pco.note
                          }}</span>
                      </vcl-form-field>
                    </form>
                  </div>
                </voxel-form-selection>
              </div>
            </voxel-card>
          </div>
        </div>
        <div *ngIf="isGrayZone" [ngClass]="{'benefits': !isGrayZone }">
          <h1 class="gz-tittle">{{ copyService.copies[copyProperty].body_title }}</h1>
          <div class="alliances">
            <vcl-card-template *ngFor="let alliance of aliances" image='assets/images/{{alliance.img}}'
              [title]="alliance.name" [paragraph]="alliance.body" buttonAlignment="vertical">
            </vcl-card-template>
          </div>
          <p id="allianceDescription" class="description" [innerHTML]="copyService.copies[copyProperty].body_description">
          </p>
          <div class="link">
            <strong *ngIf="channelId == '141'">{{copyService.copies[copyProperty].body_link}}</strong>
            <vcl-link  *ngIf="channelId != '141'" (click)="openLink()" [label]="copyService.copies[copyProperty].body_link" class="termsLink" [linkId]="'alliances'">
            </vcl-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-controls *ngIf="isGrayZone" id="succesPcoButtons" [hasPrevious]="true"
  [previousLabel]="copyService.copies[copyProperty].back_buttons"
  [nextLabel]="copyService.copies[copyProperty].forward_buttons" (previous)="exit()" (next)="next()"></app-controls>
<div>
  <app-controls class="buttonsmodifittc" *ngIf="!isGrayZone" id="succesPcoButtons" [nextDisabled]="!aproved"
    [nextLabel]="copyService.copies[copyProperty].forward_buttons_2" (next)="next()">
  </app-controls>
</div>